export default __webpack_public_path__ + "img-torre-2.26e9ec3.svg";